import React, { useState, useEffect, useCallback, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import { Redirect, useLocation } from 'react-router';
import TextField from '@mui/material/TextField';
import ShipperAddress from "app/components/Address/Shipperaddress.js";
import ConsigneeAddress from "app/components/Address/Consigneeaddress.js";
import Typography from '@mui/material/Typography';
import AddAddress from "app/components/Address/addaddress.js";
import Autocomplete from '@mui/material/Autocomplete';
import PackagesForm from "app/components/ShipmentPackages/PackagesFormD.js";
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DatePicker } from '@mui/lab';
import ContactDetails from "app/components/Address/ContactDetails.js";
import Grid from '@material-ui/core/Grid'
import ShipperAddressAlternative from "app/components/Address/ShipperaddressNotAccountHolder.js";
import { greenColor } from 'app/layout/material-dashboard-react';
import { Checkbox, Chip, Input } from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import SeaBookingSummary from "app/components/Summary/SeaBookingSummary.js";
import AirBookingSummary from "app/components/Summary/AirBookingSummary.js";
import Journey from "app/components/Journey/Journey.js";
import { PackageContext } from 'app/context/PackageContext';
import CircularProgress from '@mui/material/CircularProgress';
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import { OnClickPopoverCell } from 'app/components/DataGrid/OnClickPopoverCell';
import Iframe from "app/components/IFrame/Iframe";
import { CargoMode } from "app/types/enums";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

//Format date string
function ProcessDate(date) {
    var shortDate = date.substring(0, date.indexOf('T'));
    var [YYYY, MM, DD] = shortDate.split('-');
    var formattedShortDate = new Date(YYYY, MM - 1, DD);
    var requiredGBDate = formattedShortDate.toLocaleDateString('en-GB');
    return requiredGBDate;
}

export default function ShipmentEdit() {
    const classes = useStyles();

    const [termType, setTermType] = useState([]);
    const [cargoMode, setCargoMode] = useState([]);
    const [showPackages, setShowPackages] = useState(false);
    const [shipmentID, setShipmentID] = useState('');
    const [postTypeShipment, setPostTypeShipment] = useState('update');
    const [shipmentRef, setShipmentRef] = useState('');
    const [userAdded, setUserAdded] = useState('');
    const [dateAdded, setDateAdded] = useState();
    const [showDeleteButton] = useState(true)
    const [textShipmentButton, setTextShipmentButton] = useState('Save Edit');
    const [bookingDetails, setBookingDetails] = useState(null);
    const [collectionDate, setCollectionDate] = useState(new Date());
    const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
    const [terminal, setTerminal] = useState([]);
    const [showPortShipper, setShowPortShipper] = useState(false);
    const [showPortDelivery, setShowPortDelivery] = useState(false);
    const [terminalDestinationID, setTerminalDestinationID] = useState([]);
    const [terminalSourceID, setTerminalSourceID] = useState([]);
    const [terminalDestinationLabel, setTerminalDestinationLabel] = useState("");
    const [terminalSourceLabel, setTerminalSourceLabel] = useState("");
    const [showDetailsForm] = useState(true);
    const [showShipperContactDetails, setShowShipperContactDetails] = useState(false);
    const [showConsigneeContactDetails, setShowConsigneeContactDetails] = useState(false);
    const [shipperContactDetailsList, setShipperContactDetailsList] = useState([]);
    const [shipperAddressID, setShipperAddressID] = useState();
    const [consigneeAddressID, setConsigneeAddressID] = useState();
    const [consigneeContactDetailsList, setConsigneeContactDetailsList] = useState([]);
    const [showShipperAlternative, setShowShipperAlternative] = useState(false);
    const [hasFinalBookingStatus, setHasFinalBookingStatus] = useState(true);
    const [bookingReferences, setBookingReferences] = useState([]);
    const [currentBookingReferenceValue, setCurrentBookingReferenceValue] = useState("");
    const [bookingAttachments, setBookingAttachments] = useState([]);
    const [bookingType, setBookingType] = useState();
    const [primaryTransportMode, setPrimaryTransportMode] = useState();
    const [shipperAlternativeId, setShipperAlternativeId] = useState(0);
    const [shipperAlternativeRequired, setShipperAlternativeRequired] = useState(true);
    const [addedPackages, setAddedPackages] = useState([{}]);
    const [shipmentResponse, setShipmentResponse] = useState();
    const [selectedCargoMode, setSelectedCargoMode] = useState({ id: "", label: "", name: null, countryCode: null });
    const [pendingBooking, setPendingBooking] = useState(false);
    const { setIsLoggedIn } = useContext(LoginStatusContext);
    const [groupedDocuments, setGroupedDocuments] = useState({});

    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                    .then(() => setIsLoggedIn(true));

            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    useEffect(() => {
        handleTerminal();
        handleTermTypes();
        handleCargoModes();

        //On load populate the booking details
        const handleBookingDetails = () => {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentByID`, { params: { shipmentID: params.get("shipmentId"), getTracking: true } })
                .then((res) => {
                    //TODO set up with API to get IP address of user to determine if user is in China or the US, and set the locale setting appropriately.
                    setBookingDetails(res.data);
                    setShipmentID(res.data.shipmentID);
                    setShipmentRef(res.data.shipmentRef);
                    setUserAdded(res.data.userAdded);
                    setDateAdded(res.data.dateAdded);
                    setTerminalSourceID(res.data.sourceTerminalID);
                    setTerminalDestinationID(res.data.destinationTerminalID)
                    setTerminalSourceLabel(res.data.sourceTerminalLabel);
                    setTerminalDestinationLabel(res.data.destinationTerminalLabel)
                    setBookingType(res.data.bookingTypeID)
                    setPrimaryTransportMode(res.data.primaryTransportMode);
                    setSelectedCargoMode({ id: res.data.cargoMode });

                    if (res.data.bookingStatusID === 2) {
                        setHasFinalBookingStatus(true);
                    }

                    //Collection date
                    setCollectionDate(res.data.collectionDateTimeWindowStart);
                    var date = res.data.collectionDateTimeWindowStart;
                    if (date != null) {
                        var requiredGBDate = ProcessDate(date);
                        res.data.collectionDateTimeWindowStart = requiredGBDate;
                    }
                    //References
                    var poReferences = res.data.references.filter((reference) => {
                        return reference.informationKeyID === 13
                    }).sort(function (a, b) {
                        return b.shipmentReferenceID - a.shipmentReferenceID;
                    });

                    setBookingReferences(poReferences);

                    //Delivery date
                    if (res.data.expectedDeliveryDateTimeWindowStart !== null) {
                        setExpectedDeliveryDate(res.data.expectedDeliveryDateTimeWindowStart);
                        let deliveryDate = res.data.expectedDeliveryDateTimeWindowStart;
                        if (deliveryDate != null) {
                            let formattedDate = ProcessDate(deliveryDate);
                            res.data.expectedDeliveryDateTimeWindowStart = formattedDate;
                        }
                    }
                    //ETA date & ETD date
                    if (res.data.livePlan !== null) {
                        if (res.data.livePlan[0].estimatedArrivalDate !== null) {
                            let deliveryDate = (res.data.livePlan[0].estimatedArrivalDate);
                            if (deliveryDate != null) {
                                let formattedDate = ProcessDate(deliveryDate);
                                res.data.livePlan[0].estimatedArrivalDate = formattedDate;
                            }
                        }

                        if (res.data.livePlan[0].estimatedDepartureDate !== null) {
                            let deliveryDate = (res.data.livePlan[0].estimatedDepartureDate);
                            if (deliveryDate != null) {
                                let formattedDate = ProcessDate(deliveryDate);
                                res.data.livePlan[0].estimatedDepartureDate = formattedDate;
                            }
                        }

                        if (res.data.livePlan[0].europaPredictedArrivalDate !== null) {
                            let deliveryDate = (res.data.livePlan[0].europaPredictedArrivalDate);
                            if (deliveryDate != null) {
                                let formattedDate = ProcessDate(deliveryDate);
                                res.data.livePlan[0].europaPredictedArrivalDate = formattedDate;
                            }
                        }


                    }
                    setBookingAttachments(res.data.attachments);
                    setGroupedDocuments(groupDocumentsByType(res.data.attachments));
                })
                .catch((e) => {
                    console.error(`Booking Details GetShipmentByID error happened: ${e.message}`);
                });
        }

        //On load populate the booking packages
        const handleBookingPackages = () => {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentPackagesByID`, { params: { shipmentID: params.get("shipmentId") } })
                .then((res) => {
                    setAddedPackages(res.data);
                    setShowPackages(true);
                })
                .catch((e) => {
                    console.log('Booking Details GetShipmentPackagesByID error happened');
                });
        };

        handleBookingDetails();
        handleBookingPackages();

    }, []);

    useEffect(() => {
        if (terminalSourceID !== 0 && terminalSourceID !== '') {
            setShipperAlternativeRequired(false);
        }
        else {
            setShipperAlternativeRequired(true);
        }

    }, [terminalSourceID]);

    const handleShipperContactDetails = useCallback((contactDetails) => {
        if (contactDetails.addressId !== undefined) {
            setShipperContactDetailsList(mapContactDetails(bookingDetails[0].shipperContacts, contactDetails.contacts));
            setShipperAddressID(contactDetails.addressId);
        }
    }, [bookingDetails]);

    const handleConsigneeContactDetails = useCallback((contactDetails) => {
        if (contactDetails.addressId !== undefined) {
            setConsigneeContactDetailsList(mapContactDetails(bookingDetails[0].consigneeContacts,contactDetails.contacts))
            setConsigneeAddressID(contactDetails.addressId);
        }
    }, [bookingDetails]);

    const onCollectionDateChange = (date) => {
        setCollectionDate(date);
    };

    //On change handle the Term Types request
    const handleTermTypes = () => {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetTermTypes`)
            .then((res) => {
                setTermType(res.data);
            })
            .catch((e) => {
                console.log('Booking Details GetTermTypes error happened');
            });
    };

    //On change handle the Cargo Modes request
    const handleCargoModes = (event, value) => {

        if (value) {
            setSelectedCargoMode(value);
        }

        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetCargoModes`)
            .then((res) => {
                setCargoMode(res.data);
            })
            .catch((e) => {
                console.log('Booking Details GetCargoModes happened');
            });
    };

    const assignDefaultCargo = (defaultCargo) => {
        let newCargoMode = [...cargoMode].filter((c) => {
            return c.id === defaultCargo;
        });
        if (newCargoMode.length > 0) {
            setSelectedCargoMode(newCargoMode[0]);
            return newCargoMode[0].id;
        }
        return '';
    };

    const getDefaultTermType = (termTypeCode) => {
        handlePortPathway(null, { label: termTypeCode });
        return termTypeCode;
    };

    const handlePortPathway = (event, value) => {
        if (value.label.includes("CFR") || value.label.includes("CIF")) {
            setShowPortShipper(false);
            setShowPortDelivery(true);
            setShowShipperAlternative(false);
        }
        else if (value.label.includes("DAP") || value.label.includes("DDP")) {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
        }
        else if (value.label.includes("FCA")) {
            setShowPortShipper(true);
            setShowPortDelivery(false);
            setShowShipperAlternative(true);
            setShipperAlternativeRequired(true)
        }
        else if (value.label.includes("FOB")) {
            setShowPortShipper(true);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
        }
        else if (value.label.includes("EXW")) {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(true);
        }
        else {
            setShowPortShipper(false);
            setShowPortDelivery(false);
            setShowShipperAlternative(false);
        }

        if (value.label.includes("EXW") || value.label.includes("FCA") || value.label.includes("FOB")) {
            setShowShipperContactDetails(true);
        }
        else {
            setShowShipperContactDetails(false);
        }

        if (value.label.includes("DAP") || value.label.includes("DDP")) {
            setShowConsigneeContactDetails(true);
        }
        else {
            setShowConsigneeContactDetails(false);
        }
    }

    //On change handle the Terminal request
    const handleTerminal = (event, searchText) => {
        if (searchText) {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetTerminals`, { params: { PrimaryTransportMode: primaryTransportMode, SearchText: searchText } })
                .then((res) => {
                    setTerminal(res.data);
                    console.log("Bookings handleTerminal() getTerminals API result ");
                })
                .catch((e) => {
                    console.log("Bookings getTerminals api call did not complete");
                });
        }
        else {
            setTerminal([]);
        }
    };

    //On change obtain the terminalID selected
    const handleSourceTerminalID = (event, value) => {
        if (value) {
            setTerminalSourceID(value.id);
            setPostTypeShipment('delete');
        }
    }

    //On change obtain the terminalID selected
    const handleDestinationTerminalID = (event, value) => {
        if (value) {
            setTerminalDestinationID(value.id);
            setPostTypeShipment('delete');
        }
    }

    function reset() {
        setPostTypeShipment("delete");
    }

    const getDefaultStackMultiplier = (stackMultiplier) => {
        if (stackMultiplier === 2) {
            return "Yes";
        }

        return "No";
    };

    const mapContactDetails = (sourceContacts, contactDetails) => {
        contactDetails.forEach((contactDetail) => {
            var found = sourceContacts.find((sourceContact) => {
                return sourceContact.contactID === contactDetail.contactID;
            });
            if (found) {
                contactDetail.isSelected = found.isSelected;
                contactDetail.sourceContactID = found.sourceContactID;
                contactDetail.sourceID = found.sourceID;
            }
        });

        return contactDetails;
    };

    const onChangeShipperContact = (event, selectedContacts) => {
        var newShipperContactDetailsList = [...shipperContactDetailsList];
        newShipperContactDetailsList.forEach((shipperContactDetail) => {
            if (selectedContacts.find((selectedContact) => {
                return selectedContact.contactID === shipperContactDetail.contactID;
            })) {
                shipperContactDetail.isSelected = true;
            }
            else {
                shipperContactDetail.isSelected = false;
            }
        });

        setShipperContactDetailsList(newShipperContactDetailsList);
    }

    const onChangeConsigneeContact = (event, selectedContacts) => {
        var newConsigneeContactDetailsList = [...consigneeContactDetailsList];
        newConsigneeContactDetailsList.forEach((consigneeContactDetail) => {
            if (selectedContacts.find((selectedContact) => {
                return selectedContact.contactID === consigneeContactDetail.contactID;
            })) {
                consigneeContactDetail.isSelected = true;
            }
            else {
                consigneeContactDetail.isSelected = false;
            }
        });

        setConsigneeContactDetailsList(newConsigneeContactDetailsList);
    }

    const onBlurBookingReference = (event) => {
        if (event.target.value !== '') {
            var found = bookingReferences.find((bookingReference) => {
                return bookingReference.value === event.target.value;
            })
            if (!found) {
                var arr = [...bookingReferences];
                arr.push({
                    value: event.target.value
                });
                setBookingReferences(arr);
            }
            else {
                if (found.isDeleted === true) {
                    found.isDeleted = false;
                }
            }

            setCurrentBookingReferenceValue("");
        }
    }

    const onDeleteBookingReference = (index) => {
        let newBookingReferences = [...bookingReferences];
        newBookingReferences[index].isDeleted = true;
        setBookingReferences(newBookingReferences);
    }

    const documentOnClick = (document) => {
        if (document !== null) {
            if (document.stream) {
                openDocument(document);
            }
            else {
                axios
                    .get(`${process.env.REACT_APP_API_ENDPOINT}/api/attachment/GetAttachmentStream`, { params: { fileName: document.filename, location: document.location, attachmentContentId: document.attachmentContentId } })
                    .then((res) => {
                        if (res.data.length !== 0) {
                            document.stream = res.data;
                            openDocument(document);
                        }
                    })
                    .catch((e) => {
                        console.log('Attachment API error happened');
                    });
            }
        }
    }

    function openDocument(document) {
        const binaryString = window.atob(document.stream);
        const bytes = new Uint8Array(binaryString.length);
        const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i));
        const blob = new Blob([mappedData], { type: document.mediaType });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl);
    }

    const setShipperAddressAlternativeIdFunction = (shipperAddress) => {
        setShipperAlternativeId(shipperAddress);
    }

    const concaternateContainerDocument = (bookingAttachment) => {
        return (
            <div>
                {`${bookingAttachment.documentTypeDescription} `}
                <a onClick={() => documentOnClick(bookingAttachment)}>
                    <LaunchRoundedIcon style={{ cursor: 'pointer' }}></LaunchRoundedIcon>
                </a>
            </div>
        )
    }

    const concaternateDocumentType = (bookingAttachment, documentCount) => {
        return (
            <div>
                {documentCount > 1 && `${bookingAttachment.documentTypeDescription} ${bookingAttachment.documentReference || ''} `}
                <a onClick={() => documentOnClick(bookingAttachment)}>
                    <LaunchRoundedIcon style={{ cursor: 'pointer' }}></LaunchRoundedIcon>
                </a>
            </div>
        )
    }

    function groupDocumentsByType(documents){
        var groupedDocuments = documents.reduce((result, bookingAttachment) => {
            if (!result[bookingAttachment.documentTypeID]) {
                result[bookingAttachment.documentTypeID] = [];
            }
            result[bookingAttachment.documentTypeID].push(bookingAttachment);
            result[bookingAttachment.documentTypeID].sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded));
            return result;
        }, {});

        return groupedDocuments;
    };


    //Handle the on submit request to post the shipment 
    const onSubmit = async (e) => {
        setPendingBooking(true);
        e.preventDefault();

        const form = e.currentTarget;

        const formData = new FormData(form);
        formData.append("postType", postTypeShipment);
        formData.append("dateAdded", dateAdded);
        formData.append("userAdded", userAdded);
        formData.append("shipmentID", shipmentID);
        formData.append("shipmentRef", shipmentRef);
        formData.append("collectionDate", collectionDate.toLocaleString());

        formData.append("shipperContactDetails", JSON.stringify(shipperContactDetailsList));
        formData.append("consigneeContactDetails", JSON.stringify(consigneeContactDetailsList));
        formData.append("bookingReferences", JSON.stringify(bookingReferences));
        formData.append("bookingTypeID", bookingType);
        formData.append("primaryTransportMode", primaryTransportMode);
        formData.append("homeCostCentreId", sessionStorage.getItem('_HomeCostCentreId'));

        if (expectedDeliveryDate !== null) {
            formData.append("deliveryDate", expectedDeliveryDate.toLocaleString());
        }
        let termType = formData.get('termtype');
        if (termType.includes("CFR") || termType.includes("CIF")) {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", terminalDestinationID)
            setShowPortDelivery(true);
        }
        else if (termType.includes("DAP") || termType.includes("DDP") || termType.includes("EXW")) {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", 0)
        }
        else if (termType.includes("FCA") || termType.includes("FOB")) {
            formData.append("sourceTerminalID", terminalSourceID);
            formData.append("deliveryTerminalID", 0)
        }
        else {
            formData.append("sourceTerminalID", 0);
            formData.append("deliveryTerminalID", 0)
        }

        const plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment`, formDataJsonString)
            .then(function (response) {
                if (response !== null) {
                    if (response.status === 200) {
                        setShipmentID(response.data.shipmentId);
                        setShipmentRef(response.data.shipmentRef);
                        setUserAdded(response.data.userAdded);
                        setDateAdded(response.data.dateAdded);
                        setShipmentResponse(response.data);
                        setShowPackages(true);
                        setPostTypeShipment('update');
                        setTextShipmentButton('Save Edit')

                        try {
                            const addPackagesToShipment = async () => {
                                await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/AddPackages`, addedPackages, {
                                    params: {
                                        shipmentId: response.data.shipmentId,
                                    }
                                }).then((res) => {
                                    if (res.status === 200) {
                                        setPendingBooking(false);
                                        window.location.replace(`/LeoSeaPortal/bookingdetails?shipmentId=${response.data.shipmentId}`);
                                    }
                                });

                            }
                            addPackagesToShipment();
                        } catch (error) {
                            if (error.response) {
                                setPendingBooking(false);
                                console.error(`An error occured whilst saving packages. Status: ${error.response.status}. Detail from server: ${error.response.data.detail}.`);
                            }
                        }
                    }

                    if (postTypeShipment === "delete") {
                        window.location.replace("/LeoSeaPortal/searchbooking");
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    return (
        <div style={{ position: 'relative', zIndex: '0' }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Box sx={{ p: 2, display: 'flex' }}>
                        <Card>
                            <CardHeader style={{ backgroundColor: '#1DB35A' }}>
                                <h4 className={classes.cardTitleWhite}>Booking Details Summary</h4>
                            </CardHeader>
                            <CardBody>

                                { bookingType === 17 && (<AirBookingSummary bookingDetails={bookingDetails}> </AirBookingSummary>) }
                                { bookingType === 18 && (<SeaBookingSummary bookingDetails={bookingDetails}> </SeaBookingSummary> ) }
                                <Accordion style={{ marginTop: "40px" }} defaultExpanded={false}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#1DB35A", color: "#fff" }}>
                                        <Typography>Map</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {bookingType === 18 && (<Iframe src={bookingDetails.webPortalShareableShipmentLink} width="100%" height="600px" />)}
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#1DB35A", color: "#fff" }}>
                                        <Typography>Booking Packages</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                            <thead>
                                                <tr>
                                                    <th>Quantity</th>
                                                    <th>Type</th>
                                                    <th>Description</th>
                                                    <th>Total Gross Weight</th>
                                                    <th>Length</th>
                                                    <th>Width</th>
                                                    <th>Height</th>
                                                    <th>Volume</th>
                                                    <th>Stackable</th>
                                                    <th>Container</th>
                                                    {selectedCargoMode.id === CargoMode.FCL && (<th>Delivery Date</th>)}
                                                    <th>Document</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {addedPackages.map((item, i) =>
                                                    <tr key={`${item.packageId} - ${i}`}>
                                                        <td>{item.packageCount}</td>
                                                        <td>{item.packageTypeDescription}</td>
                                                        <td>{item.description}</td>
                                                        <td>{item.grossweight}{"\n"}{item.measureUnitsGrossWeight}</td>
                                                        <td>{item.length}{"\n"}{item.measureUnitsLength}</td>
                                                        <td>{item.width}{"\n"}{item.measureUnitsWidth}</td>
                                                        <td>{item.height}{"\n"}{item.measureUnitsHeight}</td>
                                                        <td>{item.volume}{"\n"}{item.measureUnitsVolume}</td>
                                                        <td>{getDefaultStackMultiplier(item.stackMultiplier)}</td>
                                                        <td>{item.container}</td>
                                                        {selectedCargoMode.id === CargoMode.FCL && (<td> {item.estimatedDeliveryAddress && ProcessDate(item.estimatedDeliveryAddress)} </td>)}
                                                        <td>
                                                            <OnClickPopoverCell data={bookingAttachments.filter((bookingAttachment) => {
                                                                return bookingAttachment.documentReference === item.container;
                                                            }).map(ba => {
                                                                return concaternateContainerDocument(ba);
                                                            })}
                                                            />
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#1DB35A", color: "#fff" }}>
                                        <Typography>Documents</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                            <thead >
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th>Date Added</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(groupedDocuments).map(key =>
                                                    <tr key={groupedDocuments[key][0].attachmentID}>
                                                        <td>{groupedDocuments[key][0].documentTypeDescription}</td>
                                                        <td>{new Date(groupedDocuments[key][0].dateAdded).toLocaleString()}</td>
                                                        <td>
                                                            <OnClickPopoverCell data={groupedDocuments[key].map(gd => {
                                                                return concaternateDocumentType(gd, groupedDocuments[key].length);
                                                            })}
                                                            />
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionDetails>
                                </Accordion>
                            </CardBody>
                        </Card>
                    </Box>
                </GridItem>
            </GridContainer>
        </div>
    );
}